<template>
	<div>
		<v-dialog v-model="visible" persistent max-width="500px">
			<v-card>
				<v-card-title>
					<v-icon style="margin-right: 10px"> {{ 'mdi-menu-edit' }} </v-icon>
					{{ title }}
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="formValid" v-if="item">
						<v-row align="start" style="margin-top: 10px" class="pa-0 ma-0">
							<v-col class="pa-0 ma-0">
								<v-text-field v-model="item.title" label="메뉴명"></v-text-field>
							</v-col>
						</v-row>
						<v-row align="start" style="margin-top: 10px" class="pa-0 ma-0">
							<v-col class="pa-0 ma-0">
								<v-text-field
									v-model="item.offerMinPrice"
									label="제안 최소 금액 (원)"
									type="number"
									:rules="[
										v => !!v || '값을 입력해주세요',
										v => v >= 1000 || '최소 금액은 1,000원입니다',
										v => v <= 1000000 || '최대 금액은 1,000,000원입니다',
									]"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row align="start" style="margin-top: 10px" class="pa-0 ma-0">
							<v-col class="pa-0 ma-0">
								<v-switch v-model="item.useYn" label="사용 여부"></v-switch>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-right">
					<v-spacer></v-spacer>
					<v-btn rounded :color="$theme.red" dark elevation="0" @click="$emit('onDelete')">삭제</v-btn>
					<v-btn rounded :color="$theme.primary" dark elevation="0" @click="onOk">저장</v-btn>
					<v-btn rounded :color="$theme.lightGrey" dark elevation="0" @click="$emit('onCancel')">닫기</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 처리중입니다 다이얼로그 -->
		<MessageDialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />
	</div>
</template>

<script>
	export default {
		name: 'MenuEditDialog',
		props: {
			show: {
				default: false,
			},
			icon: {
				default: '',
			},
			title: {
				default: '',
			},
			okButtonText: {
				default: 'Confirm',
			},
			cancelButtonText: {
				default: 'Cancel',
			},
			deleteButtonText: {
				default: 'Delete',
			},
			item: {
				default: {},
			},
		},
		data: () => ({
			visible: false,
			items: [],
			formValid: false,
			workingStateDialog: false,
			selectReservationDialog: false,
		}),
		watch: {
			async show() {
				this.visible = this.show;
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				});

				if (this.$utils.isEmpty(this.item.id) == false) {
					this.menus = await this.$database.loadMenus(this.item.id);
				}
			},
			async item() {},
		},
		mounted() {
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			handleKeydown(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					this.$emit('onCancel');
				}
			},
			onOk() {
				this.$refs.form.validate();
				if (this.formValid) {
					this.$emit('onOk', this.item);
				}
			},
		},
	};
</script>
